module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/doctor02-44e26d5a01302e375b2d93c5d944c69a.png";